import { IdNameList } from "../../../../../../../../../api/services/common/models";
import { Topic } from "../../../../../../../../../api/services/project/model";
import { AddDeliverableType } from "../../../../../../../../../helpers/constants";
import {
  KeyValue,
  LabelValue,
} from "../../../../../../../../../helpers/types/common";

export const ProjectActivitiesFormKeys = {
  activityType: "activityType",
  modality: "modality",
  topic: "topicName",
  activityStatus: "activityStatus",
  units: "units",
  measurement: "measurement",
  tableBody: "tableBody",
  tableRow: "tableRow",
  tableFooter: "tableFooter",
  tablePagination: "tablePagination",
  projectFramework: "projectFramework",
} as const;

export const ProjectDeliverablesFormKeys = {
  name: "name",
  deliverableType: "deliverableType",
  units: "units",
  measurements: "measurement",
  activityTypes: "activityTypes",
  tableBody: "tableBody",
  tableRow: "tableRow",
  tableFooter: "tableFooter",
  tablePagination: "tablePagination",
  activityType: "activityType",
} as const;

export interface ProjectActivitiesAndDeliverablesProps {
  rows: ProjectActivitiesRowValue[];
  deliverableRows: ProjectDeliverablesRowValue[];
  onCreateActivityClick: () => void;
  successHandler: () => void;
  successHandlerDeliverables: () => void;
  isView?: boolean;
  onCreateDeliverableClick: () => void;
}

export interface ProjectActivitiesRowValue
  extends Omit<Topic, "projectFramework" | "activityType"> {
  modality: string[];
  topicName: string;
  activityStatus: string;
  activityType: string;
  [key: string]: any;
}

export interface ProjectDeliverablesRowValue {
  id: string;
  name: string | null;
  deliverableType: string;
  units: string;
  measurement: string;
  activityTypes: ActivityType[];
  [key: string]: any;
  isProjectFrameworkDeliverable?: boolean;
  activityType?: string[];
}

export interface ActivityType {
  id: string;
  name: string | null;
}

export interface ProjectDeliverableUniqueFiltersTypes {
  activityTypes: LabelValue[];
  deliverableType: LabelValue[];
  units: LabelValue[];
  activityType: LabelValue[];
}

export interface UpdateDeliverablesFormProps {
  units: string;
  measurementMinute: string;
  measurementOther: number | null;
}

export const ProjectUpdateDeliverablesFormKeys = {
  units: "units",
  measurementMinute: "measurementMinute",
  measurementOther: "measurementOther",
} as const;

export const ProjectCreateActivityDefaultFormKeys = {
  units: "units",
  measurementMinute: "measurementMinute",
  measurementOther: "measurementOther",
  measurement: "measurement",
  mesurementName: "mesurementName",
} as const;

export const ProjectCreateActivityGeneralFormKeys = {
  candidateStatuses: "candidateStatuses",
  activityType: "activityType",
  modality: "modality",
  topic: "topic",
  deliverables: "deliverables",
  activityStatus: "activityStatus",
  triggerBilling: "triggerBilling",
  lastContactDate: "lastContactDate",
  triggerTouch: "triggerTouch",
} as const;

export interface EditActivityValueProps
  extends Omit<ProjectCreateActivityGeneralProps, "activityType">,
    ProjectCreateActivityDefaultProps {
  activityType: IdNameList;
  projectFrameworkId?: string;
}

export interface ProjectCreateActivityGeneralProps {
  activityType: string;
  modality: string[];
  topic: KeyValue;
  deliverables: string[];
  activityStatus: string;
  triggerBilling: boolean;
  lastContactDate: boolean;
  triggerTouch: boolean;
}
export interface ProjectCreateActivityDefaultProps {
  units: string;
  measurementMinute: string;
  measurementOther: number | null;
}

export const ProjectCreateDeliverablesFormKeys = {
  addDeliverableType: "addDeliverableType",
  deliverableType: "deliverableType",
  name: "name",
  units: "units",
  measurementMinute: "measurementMinute",
  measurementOther: "measurementOther",
} as const;

export interface ProjectCreateDeliverablesFormProps {
  addDeliverableType: AddDeliverableType;
  deliverableType: string;
  name: KeyValue;
  units: string;
  measurementMinute: string;
  measurementOther: number | null;
}

export interface ProjectExistingDeliverableFilterFormProps {
  name: string;
  deliverableType: string;
  units: string;
}

export const ProjectExistingDeliverableFormKeys = {
  deliverableType: "deliverableType",
  units: "units",
  measurements: "measurements",
  isSelected: "isSelected",
  id: "id",
  name: "name",
  unitName: "unitName",
  deliverableTypeName: "deliverableTypeName",
} as const;

export interface ProjectExistingDeliverablesType {
  deliverableType: string;
  units: string;
  measurement: number;
  isSelected: boolean;
  id: string;
  name: string;
  unitName: string;
  deliverableTypeName: string;
  [key: string]: any;
}

export interface ProjectDeliverablesTabProps {
  rows: ProjectDeliverablesRowValue[];
  tableRef: React.RefObject<any>;
  isView: boolean;
  control: any;
  uniqueFilters: ProjectDeliverableUniqueFiltersTypes;
  filteredResults: ProjectDeliverablesRowValue[];
  deleteAction: (id: string) => void;
  onProjectDeliverableViewClick: (
    data: ProjectDeliverablesRowValue,
    isEdit?: boolean,
  ) => void;
}

export interface ProjectActivitiesTabProps {
  rows: ProjectActivitiesRowValue[];
  tableRef: React.RefObject<any>;
  isView: boolean;
  control: any;
  uniqueFilters: ProjectActivityAndDeliverablesFiltersTypes;
  filteredResults: ProjectActivitiesRowValue[];
  deleteActivityOrDeliverableAction: (id: string) => void;
  onProjectActivityViewClick: (
    data: ProjectActivitiesRowValue,
    isEdit?: boolean,
  ) => void;
}

export interface ProjectActivityAndDeliverablesFiltersTypes {
  activityType: LabelValue[];
  modality: LabelValue[];
  units: LabelValue[];
  projectFramework: LabelValue[];
}

export interface ProjectViewActivityResponse {
  id?: string;
  activityType: IdNameList;
  modalities: string[];
  topicName: string;
  activityStatus: string;
  units: string;
  candidateStatuses: string[];
  triggerBilling: boolean;
  countsTowardsLastContactDate: boolean;
  triggerTouchPointSurvey: boolean;
  measurement: string;
  deliverables: {
    id: string;
    name: string;
  }[];
}
